import React from 'react';

import { Button } from '@amzn/awsui-components-react-v3';

import { useGetUserInformation, logger } from 'appSelectorContext';

import { Serial } from '../../store/types';

interface ReceivePartsActionProps {
  disabled: boolean;
  onReceiveParts: () => void;
  model: any;
  overrage: boolean;
  underage: boolean;
  allSerials: Serial[];
}

export const ReceivePartsAction = ({ disabled, onReceiveParts }: ReceivePartsActionProps) => {
  const { user } = useGetUserInformation();
  const onHandleReceiveParts = () => {
    logger.info(
      `submitting receive request : ${JSON.stringify({
        withUser: user,
      })} `,
    );
    onReceiveParts();
  };

  return (
    <Button variant="primary" disabled={disabled} ariaLabel="receive-parts" onClick={onHandleReceiveParts}>
      Receive Parts
    </Button>
  );
};
